import { useState, useEffect } from "react";
import {
  Heart,
  Users,
  Globe,
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Menu,
  X,
  Linkedin,
} from "lucide-react";
import "../App.css";
import logo from "../assets/Relief.png";
import slide1 from "../assets/banner.jpg";
import slide2 from "../assets/banner2.jpg";
import slide3 from "../assets/banner3.jpg";
import slide4 from "../assets/slide4.jpg";

import ourmission from "../assets/ourmission1.jpg";

import donation from "../assets/donation1.jpg";
import TeamCarousel from "./TeamCarousel";

import team1 from "../assets/team1.jpg";
import team2 from "../assets/team2.jpg";
import team3 from "../assets/team3.jpg";
import team5 from "../assets/team5.jpg";
import team6 from "../assets/team6.jpg";

import product1 from "../assets/product1.jpg";
import product2 from "../assets/product2.jpg";
import product3 from "../assets/product3.jpg";
import product4 from "../assets/product4.jpg";
import product5 from "../assets/product5.jpg";
import product6 from "../assets/product6.jpg";
import product7 from "../assets/product7.jpg";
import product8 from "../assets/product8.jpg";

import ProductShowcase from "./ProductShowcase";
import Modal from "./Modal";
import ImageGallery from "./ImageGallery";

function NgoLandingPage() {
  // Carousel state
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const servicess = [
    { name: 'RELIEF KIT BY CLAK', description: `We believe that every period deserves care, comfort and dignity which is why we provide 
quality Access to Menstrual products to women most especially Students nationwide. These 
period packs  are made portable and handy for students to use at any point in time and at 
any location.  
We render educational TALKS on campuses on Menstrual Hygiene and it’s benefits to create 
a concrete understanding of how to use and dispose off menstrual products.  
We promote safe and Stigma- Free environments where students of all gender feel 
empowered to learn about Menstrual flow or Menstruation. 
Relief Kit by Clak is a reliable companion for managing menstrual flow and the source of the 
Comfort you need in that time of the month.` },
    
  ];

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const carouselImages = [slide1, slide2, slide3, slide4];

  // Team members data
  const teamMembers = [
    {
      name: "Comfort Konadu Asante",
      role: "Chief Executive Officer",
      bio: "Comfort oversees the day to day activities in the organisation.",
      image: team5,
      socialLinks: [
        {
          platform: "LinkedIn",
          url: "#",
          icon: <Linkedin className="h-5 w-5" />,
        },
        {
          platform: "Twitter",
          url: "#",
          icon: <Twitter className="h-5 w-5" />,
        },
      ],
    },
    {
      name: "Mariegold Abena Adubea",
      role: "Brand Ambassador",
      bio: "Mariegold oversees our global Brands and ensures efficient resource allocation across all projects.",
      image: team3,
      socialLinks: [
        {
          platform: "LinkedIn",
          url: "#",
          icon: <Linkedin className="h-5 w-5" />,
        },
        {
          platform: "Twitter",
          url: "#",
          icon: <Twitter className="h-5 w-5" />,
        },
      ],
    },
    {
      name: "Leticia Enyonam Sateklah",
      role: "The seal initiative advocate",
      bio: "Leticia oversees our global seal initiative and ensures efficient resource allocation across all projects.",
      image: team6,
      socialLinks: [
        {
          platform: "LinkedIn",
          url: "#",
          icon: <Linkedin className="h-5 w-5" />,
        },
        {
          platform: "Twitter",
          url: "#",
          icon: <Twitter className="h-5 w-5" />,
        },
      ],
    },
    {
      name: "Other Members",
      role: "Program Manager",
      bio: "Other Members leads our education initiatives and has implemented successful programs in over 10 countries.",
      image: team2,
      socialLinks: [
        {
          platform: "LinkedIn",
          url: "#",
          icon: <Linkedin className="h-5 w-5" />,
        },
        {
          platform: "Twitter",
          url: "#",
          icon: <Twitter className="h-5 w-5" />,
        },
      ],
    },
  ];

  // Product data for sanitary pads
  const products = [
    {
      name: "Comfort Plus Sanitary Pads",
      price: 3.99,
      oldPrice: 5.99,
      discount: 33,
      description:
        "Ultra-thin, highly absorbent pads with wings for maximum protection and comfort.",
      image: team1,
      features: ["Ultra-thin", "Wings", "Breathable"],
    },
    {
      name: "Overnight Protection Pads",
      price: 4.99,
      description:
        "Extra-long pads designed for overnight use with enhanced absorbency and leak protection.",
      image: "https://via.placeholder.com/600x400?text=Overnight+Pads",
      features: ["Extra-long", "Super absorbent", "Odor control"],
    },
    {
      name: "Eco-Friendly Organic Pads",
      price: 5.99,
      oldPrice: 7.99,
      discount: 25,
      description:
        "Made with 100% organic cotton, biodegradable and free from harmful chemicals.",
      image: "https://via.placeholder.com/600x400?text=Organic+Pads",
      features: ["Organic", "Biodegradable", "Chemical-free"],
    },
    {
      name: "Teen Starter Kit",
      price: 8.99,
      description:
        "Complete kit for young girls including pads, educational materials, and a discreet carrying pouch.",
      image: "https://via.placeholder.com/600x400?text=Teen+Starter+Kit",
      features: ["Educational", "Variety pack", "Discreet pouch"],
    },
    {
      name: "School Distribution Pack",
      price: 24.99,
      description:
        "Bulk pack designed for school distribution programs, containing 50 individually wrapped pads.",
      image:
        "https://via.placeholder.com/600x400?text=School+Distribution+Pack",
      features: ["Bulk pack", "Individually wrapped", "Cost-effective"],
    },
    {
      name: "Reusable Cloth Pads Set",
      price: 15.99,
      oldPrice: 19.99,
      discount: 20,
      description:
        "Set of 5 washable, reusable cloth pads with waterproof backing and snap wings.",
      image: "https://via.placeholder.com/600x400?text=Reusable+Cloth+Pads",
      features: ["Reusable", "Eco-friendly", "Cost-saving"],
    },
  ];

  // Automatically cycle through carousel images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Close mobile menu when clicking on a link
  const handleNavLinkClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-50 border-b bg-white shadow-sm md:mx-2">
        <div className="container flex h-16 items-center justify-between py-4">
          <div className="flex items-center gap-2">
            <img src={logo} alt="Logo" className="h-[65px] w-[65px]" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex gap-6">
            <a
              href="#home"
              className="text-sm font-medium hover:text-purple-500"
            >
              Home
            </a>
            <a
              href="#about"
              className="text-sm font-medium hover:text-purple-500"
            >
              About Us
            </a>

            <a
              href="#donate"
              className="text-sm font-medium hover:text-purple-500"
            >
              Product
            </a>
            <a
              href="#contact"
              className="text-sm font-medium hover:text-purple-500"
            >
              Contact
            </a>
          </nav>

          <div className="flex items-center gap-4">
            <button className="hidden md:flex h-9 px-4 py-2 text-sm font-medium border rounded-md shadow-sm hover:bg-gray-50">
              Volunteer
            </button>
            {/* <button className="h-9 px-4 py-2 text-sm font-medium text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600">
              Projects
            </button> */}
            <ImageGallery />
            <button
              className="md:hidden flex items-center justify-center"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b shadow-lg z-50">
            <nav className="container py-4 flex flex-col space-y-4">
              <a
                href="#home"
                className="text-base font-medium hover:text-purple-500 px-2 py-2"
                onClick={handleNavLinkClick}
              >
                Home
              </a>
              <a
                href="#about"
                className="text-base font-medium hover:text-purple-500 px-2 py-2"
                onClick={handleNavLinkClick}
              >
                About Us
              </a>

              <a
                href="#donate"
                className="text-base font-medium hover:text-purple-500 px-2 py-2"
                onClick={handleNavLinkClick}
              >
                Product
              </a>
              <a
                href="#contact"
                className="text-base font-medium hover:text-purple-500 px-2 py-2"
                onClick={handleNavLinkClick}
              >
                Contact
              </a>
              <button className="text-left text-base font-medium hover:text-purple-500 px-2 py-2">
                Volunteer
              </button>
            </nav>
          </div>
        )}
      </header>

      <main className="flex-1">
        <section id="home" className="relative">
          {/* Carousel */}
          <div className="carousel-container">
            {carouselImages.map((image, index) => (
              <div
                key={index}
                className={`carousel-slide absolute inset-0 transition-opacity duration-1000 ${
                  index === currentSlide ? "opacity-80" : "opacity-0"
                }`}
              >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <img
                  src={
                    image ||
                    `https://via.placeholder.com/1920x800?text=Slide+${
                      index + 1
                    }`
                  }
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}

            {/* Carousel navigation dots */}
            <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
              {carouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full ${
                    index === currentSlide
                      ? "bg-white"
                      : "bg-white bg-opacity-50"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="container relative z-10 flex flex-col items-center justify-center space-y-4 py-16 text-center sm:py-20 md:py-28 lg:py-36">
            <div className="space-y-2 px-4 sm:px-6 mt-5 sm:mt-0">
              <h1 className="text-2xl font-bold tracking-tighter text-white sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
                Relief Kit by Clak
              </h1>
              <p className="mx-auto max-w-[700px] text-white/90 text-base sm:text-lg md:text-xl">
                Join us in our mission to create lasting change in Girls
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full px-4 sm:justify-center sm:gap-4 sm:px-0">
              <button className="w-full sm:w-auto px-4 py-3 text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600 font-medium text-sm sm:text-base invisible sm:visible">
                Product
              </button>
              <button 
               onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}
              className="w-full sm:w-auto px-4 py-3 text-white border border-purple-500 rounded-md shadow-sm hover:bg-white/10 font-medium text-sm sm:text-base text-center sm:text-left"
              >
                Learn More
              </button>
            </div>
          </div>
        </section>

        <section
          id="about"
          className="bg-white py-12 sm:py-16 md:py-20 lg:py-24"
        >
          <div className="container px-4 sm:px-6">
            <div className="flex flex-col gap-8 md:flex-row md:gap-12">
              <div className="w-full md:w-1/2">
                <div className="relative h-[250px] sm:h-[300px] md:h-full overflow-hidden rounded-lg">
                  <img
                    src={ourmission}
                    alt="Our mission"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex flex-col justify-center space-y-4 w-full md:w-1/2">
                <div className="inline-block rounded-lg bg-purple-100 px-3 py-1 text-sm text-purple-700">
                  Our Mission
                </div>
                <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                  Provide Comfort and Support to women before, during and after
                  their Menstrual Flow.
                </h2>
                <p className="text-gray-600 text-base sm:text-lg">
                  Relief Kit by Clak is a “Girl-Emergency “ kit designed to
                  support Menstrual Health and provide comfort, confidence and
                  care before, during and after Menstruation. Our Menstrual Kit
                  is thoughtfully packaged with quality sanitary essentials to
                  help you manage your menstrual cycle with ease – whether home,
                  work or school. This Period Pack contains Sanitary Pads,
                  tampons, liners , wipes, underwear, heating patches, hand
                  sanitizer, pair of socks , towel and a bar of soap. These
                  products are accompanied by ginger tea bags, Chocolates and
                  yogurt for some women who crave desserts during their period.
                  Our Menstrual kit is made to curb period uncertainty among
                  women and help them stay informed and prepared.
                </p>
                <ul className="grid gap-2">
                  <li className="flex items-center gap-2">
                    <div className="rounded-full bg-green-100 p-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-4 w-4 text-green-600"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <span>
                      Access to Menstrual products to women most especially
                      Students nationwide.
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="rounded-full bg-green-100 p-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-4 w-4 text-green-600"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <span>
                      We render educational TALKS on campuses on Menstrual
                      Hygiene.
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="rounded-full bg-green-100 p-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-4 w-4 text-green-600"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    </div>
                    <span>We promote safe and Stigma- Free environments</span>
                  </li>
                </ul>
                <div>
                  <button onClick={handleOpenModal} className="px-4 py-2 text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600 font-medium text-sm sm:text-base">
                    Learn About Our Work
                  </button>
                  <Modal isOpen={isModalOpen} onClose={handleCloseModal} services={servicess} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section
          id="work"
          className="bg-slate-50 py-12 sm:py-16 md:py-20 lg:py-24"
        >
          <div className="container px-4 sm:px-6 space-y-8 sm:space-y-12">
            <div className="flex flex-col items-center justify-center space-y-4 text-center">
              <div className="inline-block rounded-lg bg-purple-100 px-3 py-1 text-sm text-purple-700">
                Our Impact
              </div>
              <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                Areas We Focus On
              </h2>
              <p className="mx-auto max-w-[700px] text-gray-600 text-base sm:text-lg">
                We concentrate our efforts where we can make the most
                significant difference, addressing critical needs in communities
                around the world.
              </p>
            </div>

            <div className="grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3">
              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <Users className="h-6 w-6 text-purple-600" />
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">Education</h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Providing quality education and learning opportunities for
                  children and adults in underserved communities.
                </p>
              </div>

              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-6 w-6 text-purple-600"
                  >
                    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                  </svg>
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">
                  Healthcare
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Improving access to essential healthcare services and
                  promoting health education in vulnerable communities.
                </p>
              </div>

              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-6 w-6 text-purple-600"
                  >
                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                    <line x1="7" y1="7" x2="7.01" y2="7" />
                  </svg>
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">
                  Clean Water
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Developing sustainable water solutions and sanitation
                  facilities to improve health and quality of life.
                </p>
              </div>

              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <Globe className="h-6 w-6 text-purple-600" />
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">
                  Environment
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Promoting sustainable practices and conservation efforts to
                  protect natural resources and ecosystems.
                </p>
              </div>

              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-6 w-6 text-purple-600"
                  >
                    <path d="M2 9V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1" />
                    <path d="M2 13h10" />
                    <path d="m9 16 3-3-3-3" />
                  </svg>
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">
                  Disaster Relief
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Providing immediate assistance and long-term recovery support
                  to communities affected by natural disasters.
                </p>
              </div>

              <div className="group relative overflow-hidden rounded-lg border bg-white p-5 sm:p-6 shadow-sm transition-all hover:shadow-md">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-purple-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="h-6 w-6 text-purple-600"
                  >
                    <path d="M12 2v20" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                  </svg>
                </div>
                <h3 className="mb-2 text-lg sm:text-xl font-bold">
                  Economic Development
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">
                  Supporting entrepreneurship and creating economic
                  opportunities to help communities thrive and become
                  self-sufficient.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* Team Section with Carousel (Replacing "Areas We Focus On") */}
        <section
          id="team"
          className="bg-slate-50 py-12 sm:py-16 md:py-20 lg:py-24"
        >
          <div className="container px-4 sm:px-6 space-y-8 sm:space-y-12">
            <div className="flex flex-col items-center justify-center space-y-4 text-center">
              <div className="inline-block rounded-lg bg-purple-100 px-3 py-1 text-sm text-purple-700">
                Our Team
              </div>
              <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                Meet the People Behind Our Mission
              </h2>
              <p className="mx-auto max-w-[700px] text-gray-600 text-base sm:text-lg">
                Our dedicated team of professionals brings diverse expertise and
                a shared passion for creating positive change around the world.
              </p>
            </div>

            {/* Team Carousel Component */}
            <div className="px-4 sm:px-6">
              <TeamCarousel teamMembers={teamMembers} />
            </div>
          </div>
        </section>

        {/* Products Section - Replacing "Our Global Impact" */}

        <section
          id="donate"
          className="bg-purple-50 py-12 sm:py-16 md:py-20 lg:py-24"
        >
          <div className="container px-4 sm:px-6">
            <div className="flex flex-col gap-8 md:flex-row md:gap-12">
              <div className="flex flex-col justify-center space-y-4 w-full md:w-1/2">
                <div className="inline-block rounded-lg bg-purple-100 px-3 py-1 text-sm text-purple-700">
                  Support Our Cause
                </div>
                <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                  Your Purchase makes a difference
                </h2>
                <p className="text-gray-600 text-base sm:text-lg">
                  Every purchase, no matter the size, helps us continue our
                  mission of creating lasting change in the girl child
                </p>

                <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product8}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product3}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product4}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product5}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product6}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                  <div className="rounded-lg border bg-white p-4 text-center shadow-sm">
                    <img
                      src={product7}
                      alt="Card Image"
                      className="w-full max-h-40 object-cover rounded-lg transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </div>
                </div>

                {/* <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
                  <button className="w-full sm:w-auto px-4 py-2 text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600 font-medium text-sm sm:text-base">
                    Donate Now
                  </button>
                  <button className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 font-medium text-sm sm:text-base">
                    Become a Monthly Donor
                  </button>
                </div> */}
              </div>

              <div className="w-full md:w-1/2 mt-6 md:mt-0">
                <div className="relative h-[250px] sm:h-[300px] md:h-full overflow-hidden rounded-lg">
                  <img
                    src={donation}
                    alt="Donation impact"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="py-12 sm:py-16 md:py-20 lg:py-24">
          <div className="container px-4 sm:px-6">
            <div className="mx-auto max-w-4xl">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                  Get in Touch
                </h2>
                <p className="mt-4 text-gray-600 text-base sm:text-lg">
                  Have questions or want to learn more about our work? We'd love
                  to hear from you.
                </p>
              </div>

              <div className="grid gap-8 md:grid-cols-2">
                <div className="space-y-6">
                  <div className="flex items-center gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100">
                      <MapPin className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      {/* <h3 className="font-medium">Our Address</h3> */}
                      <p className="text-gray-600 text-sm sm:text-base">
                        123 Dansoman Street, Dansoman City
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100">
                      <Mail className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      {/* <h3 className="font-medium">Email Us</h3> */}
                      <p className="text-gray-600 text-sm sm:text-base">
                        info@reliefkitbyclak.org
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100">
                      <Phone className="h-5 w-5 text-purple-600" />
                    </div>
                    <div>
                      {/* <h3 className="font-medium">Call Us</h3> */}
                      <p className="text-gray-600 text-sm sm:text-base">
                        +233 (541) 783-046 OR +233 (537) 681-876
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-center gap-4">
                    <a
                      href="#"
                      className="rounded-full bg-slate-100 p-2 hover:bg-slate-200"
                    >
                      <Facebook className="h-5 w-5" />
                      <span className="sr-only">Facebook</span>
                    </a>
                    <a
                      href="#"
                      className="rounded-full bg-slate-100 p-2 hover:bg-slate-200"
                    >
                      <Twitter className="h-5 w-5" />
                      <span className="sr-only">Twitter</span>
                    </a>
                    <a
                      href="#"
                      className="rounded-full bg-slate-100 p-2 hover:bg-slate-200"
                    >
                      <Instagram className="h-5 w-5" />
                      <span className="sr-only">Instagram</span>
                    </a>
                    <a
                      href="#"
                      className="rounded-full bg-slate-100 p-2 hover:bg-slate-200"
                    >
                      <Youtube className="h-5 w-5" />
                      <span className="sr-only">YouTube</span>
                    </a>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="grid gap-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label
                          htmlFor="first-name"
                          className="text-sm font-medium leading-none"
                        >
                          First name
                        </label>
                        <input
                          id="first-name"
                          placeholder="John"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                        />
                      </div>
                      <div className="space-y-2">
                        <label
                          htmlFor="last-name"
                          className="text-sm font-medium leading-none"
                        >
                          Last name
                        </label>
                        <input
                          id="last-name"
                          placeholder="Doe"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                        />
                      </div>
                    </div>
                    <div className="space-y-2">
                      <label
                        htmlFor="email"
                        className="text-sm font-medium leading-none"
                      >
                        Email
                      </label>
                      <input
                        id="email"
                        placeholder="johndoe@example.com"
                        type="email"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      />
                    </div>
                    <div className="space-y-2">
                      <label
                        htmlFor="message"
                        className="text-sm font-medium leading-none"
                      >
                        Message
                      </label>
                      <textarea
                        id="message"
                        placeholder="Your message here..."
                        className="w-full min-h-[120px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      ></textarea>
                    </div>
                  </div>
                  <button className="w-full px-4 py-2 text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600 font-medium text-sm sm:text-base">
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-slate-50 py-12 sm:py-16 md:py-20 lg:py-24">
          <div className="container px-4 sm:px-6">
            <div className="mx-auto max-w-3xl text-center">
              <h2 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
                Join Our Newsletter
              </h2>
              <p className="mt-4 text-gray-600 text-base sm:text-lg">
                Stay updated with our latest projects, events, and ways to get
                involved.
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-center">
                <input
                  placeholder="Enter your email"
                  className="w-full sm:max-w-sm px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                />
                <button className="w-full sm:w-auto px-4 py-2 text-white bg-purple-500 rounded-md shadow-sm hover:bg-purple-600 font-medium text-sm sm:text-base">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-slate-900 text-slate-200 py-12 md:py-16">
        <div className="container px-4 sm:px-6">
          <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <img src={logo} />
                {/* <Heart className="h-6 w-6 text-purple-500" />
                <span className="text-xl font-bold text-white">
                  HelpingHands
                </span> */}
              </div>
              <p className="text-slate-400 mb-4 text-sm sm:text-base">
                Making a difference in communities around the world since 2005.
              </p>
              <div className="flex gap-4">
                <a href="#" className="text-slate-400 hover:text-white">
                  <Facebook className="h-5 w-5" />
                  <span className="sr-only">Facebook</span>
                </a>
                <a href="#" className="text-slate-400 hover:text-white">
                  <Twitter className="h-5 w-5" />
                  <span className="sr-only">Twitter</span>
                </a>
                <a href="#" className="text-slate-400 hover:text-white">
                  <Instagram className="h-5 w-5" />
                  <span className="sr-only">Instagram</span>
                </a>
                <a href="#" className="text-slate-400 hover:text-white">
                  <Youtube className="h-5 w-5" />
                  <span className="sr-only">YouTube</span>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-medium text-white mb-4">
                Quick Links
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#home"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="#work"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Our Work
                  </a>
                </li>
                <li>
                  <a
                    href="#donate"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Donate
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium text-white mb-4">
                Get Involved
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Volunteer
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Fundraise
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Partner With Us
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Corporate Sponsorship
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-slate-400 hover:text-white text-sm sm:text-base"
                  >
                    Planned Giving
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-medium text-white mb-4">
                Contact Us
              </h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <MapPin className="h-5 w-5 text-purple-500 mt-0.5" />
                  <span className="text-slate-400 text-sm sm:text-base">
                    123 Dansoman Street, Dansoman City, 10001
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <Mail className="h-5 w-5 text-purple-500 mt-0.5" />
                  <span className="text-slate-400 text-sm sm:text-base">
                    info@reliefkitbyclak.org
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <Phone className="h-5 w-5 text-purple-500 mt-0.5" />
                  <span className="text-slate-400 text-sm sm:text-base">
                    +233 (541) 783-046 OR +233 (537) 681-876
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 border-t border-slate-800 pt-8 text-center">
            <p className="text-slate-400 text-sm sm:text-base">
              &copy; {new Date().getFullYear()} CLAK. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default NgoLandingPage;
